<template>
    <v-row
        align="center"
        justify="center"
      >
        <v-col
          cols="12"
          sm="8"
          md="4"
          v-if="!showSentEmail"
        >
          <v-card outlined :loading="loading">
            <v-card-title>Reset your Password</v-card-title>
            <v-card-subtitle>
                Enter the email address associated with your account and we’ll email a link to reset your password.
            </v-card-subtitle>
            
            <v-form
              ref="form"
              v-model="valid"
              @submit.prevent="sendResetPasswordEmail"
            >
              <v-card-text class="pb-0">
                    <v-alert
                        text
                        prominent
                        color="primary"
                        icon="priority_high"
                        v-if="error!=''"
                    >
                    <v-row align="center" no-gutters>
                      <v-col class="grow">{{error}}</v-col>
                    </v-row>
                  </v-alert>
                 <v-text-field
                  label="Email"
                  name="email"
                  prepend-inner-icon="mdi-account"
                  outlined
                  type="text"
                  v-model="email"
                  :rules="emailRules"
                  required
                  :validate-on-blur="isFirstSubmissionAttempt"
                ></v-text-field>
              </v-card-text>
              <v-card-actions class="px-4 pb-3 pt-5">                
                <v-btn elevation="0" block type="submit" color="primary" large class="text-body-1">Reset Password</v-btn>
              </v-card-actions>
            </v-form>
          </v-card>
          <v-row class="mt-8">
            <v-spacer></v-spacer>
              <div class="text-center text-body-1 grey--text">Back to <router-link to="/login" class="text-decoration-none font-weight-medium"><span>Log In</span></router-link></div>
            <v-spacer>
            </v-spacer>
          </v-row>
        </v-col>
        <v-col
            v-if="showSentEmail"
            cols="12"
            sm="8"
            md="4"
        >
          <v-card class="elevation-12">
            <v-toolbar
              flat
            >
              <v-spacer></v-spacer>
              <v-toolbar-title>Great! Check your Inbox</v-toolbar-title>
              <v-spacer></v-spacer>
            </v-toolbar>
            
            <v-form @submit.prevent="resendVerificationEmail">
              <v-card-text class="pb-0">
                  <div class="text-center text-body-2 grey--text">
                    <p>We have sent an email with<br/>instructions on how to reset your password to</p>
                    <p class="font-weight-bold">{{email}}</p>
                    <p>Remember to check your spam folder just in case.</p>
                    
                    <v-btn elevation="0" type="submit" color="primary" large class="px-5 mb-3 text-body-2">Resend Email</v-btn>
                  </div>
              </v-card-text>
              <v-card-actions>
                  <v-spacer/>
                  <div class="text-center text-body-2">
                      Need to change the entered email address? 
                      <p @click="editEmail" class="font-weight-bold primary--text mt-2" style="cursor:pointer;">Click here</p>
                  </div>
                     <v-spacer/>
              </v-card-actions>
            </v-form>
          </v-card>
        </v-col>
      </v-row>
</template>
<script>

import { getAuth, sendPasswordResetEmail } from 'firebase/auth';

export default {
    name: 'ForgotPassword',
    data() {
        return {
            error: '',
            showSentEmail: false,
            email: '',
            isFirstSubmissionAttempt: true,
            loading: false,
            valid: false,
            emailRules: [
                v => !!v || 'Please enter your email',
                v => /.+@.+\..+/.test(v) || 'Invalid email',
            ],
        };
    },
    methods: {
        async sendResetPasswordEmail() {
            this.error = '';
            if (this.$refs.form.validate()) {
                //Register user using firebase
                this.loading = true;
                try{
                  const auth = getAuth();
                    await sendPasswordResetEmail(auth, this.email);
                    this.loading = false;
                    this.showSentEmail = true;
                } catch(error) {
                    this.loading = false;
                    this.error = error.message || error;
                }
            }
        },
        editEmail() {
            this.email = '';
            this.showSentEmail = false
        }
    },
}
</script>